import { useSelector } from "react-redux";
import { useGetTasksQuery } from "../../../features/tasks/tasksApi";
import TaskItem from "./TaskItem";

const TaskList = () => {
  const { data: tasks, isLoading, isError } = useGetTasksQuery();

  const { filteredBy } = useSelector((state) => state.projects);

  const { searchText } = useSelector((state) => state.tasks);

  const filteredByProjects = (taskItem) => {
    return !filteredBy.includes(taskItem?.project?.projectName);
  };

  const filteredBySearch = (taskItem) => {
    if (searchText.length > 0) {
      return taskItem.taskName.toLowerCase().includes(searchText.toLowerCase());
    }
    return taskItem;
  };

  // decide what to render
  let content = "";

  if (isLoading) {
    content = <div>Loading...</div>;
  }

  if (!isLoading && isError) {
    content = <div>There was an error!</div>;
  }

  if (!isLoading && !isError && tasks?.length === 0) {
    content = <div>No tasks found!</div>;
  }

  if (!isLoading && !isError && tasks?.length > 0) {
    content = tasks
      .filter(filteredByProjects)
      .filter(filteredBySearch)
      .map((task) => <TaskItem key={task.id} task={task} />);
  }

  return <div className="lws-task-list">{content}</div>;
};

export default TaskList;
